import React from 'react';
import Carousel from '../../../../../components/presentational/Carousel/Carousel';
import { Brand } from '../../../../../lib/theme';
import CarouselBlockSlide, { CarouselSlide } from './CarouselBlockSlide';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../../../lib/styles';
import carouselBlockStyles from './CarouselBlock_styles';

export interface CarouselBlockData {
  brand: Brand;
  type: 'carousel_block' | 'acf_carousel_block';
  images: CarouselSlide[];
  makeContentWidth: boolean;
}

export interface CarouselBlockProps {
  block: CarouselBlockData;
}

const CarouselBlock = ({
  block: { brand, images, makeContentWidth = false },
}: CarouselBlockProps & StylesProps<typeof carouselBlockStyles>) => {

  return (
    <Carousel
      brand={brand}
      slideInterval={brand == 'travel360' ? 5000 : 10000}
      location="block"
    >
      {images.map((slide, key) => {
        return slide.link ? (
          <a key={key} href={slide.link} rel="noopener noreferrer">
            <CarouselBlockSlide key={key} slide={slide} brand={brand} makeContentWidth={makeContentWidth} />
          </a>
        ) : (
          <CarouselBlockSlide key={key} slide={slide} brand={brand} makeContentWidth={makeContentWidth} />
          );
      })}
    </Carousel>
  );
};

export default compose(styled(carouselBlockStyles))(CarouselBlock);
